var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    attrs: {
      "id": "searchArea"
    }
  }, [_c('el-form', {
    staticClass: "el-form-filter",
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataList(1);
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    staticClass: "wd500 input-with-select-lg",
    class: {
      hideInputActive: _vm.dataForm.noClientCode || _vm.dataForm.noLinkedEngagement
    },
    attrs: {
      "placeholder": _vm.kwPlaceHolder
    },
    model: {
      value: _vm.dataForm.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "keyword", $$v);
      },
      expression: "dataForm.keyword"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "please select"
    },
    on: {
      "change": _vm.kwTypeChange
    },
    slot: "prepend",
    model: {
      value: _vm.dataForm.kwType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "kwType", $$v);
      },
      expression: "dataForm.kwType"
    }
  }, _vm._l(_vm.kwTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "Country of Company"
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "select coordinator",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.coordinatorIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "coordinatorIds", $$v);
      },
      expression: "dataForm.coordinatorIds"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Unassigned",
      "value": -1
    }
  }), _vm._l(_vm.userList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.nickname || item.username,
        "value": item.id
      }
    });
  })], 2)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "select checker",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.checkerIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "checkerIds", $$v);
      },
      expression: "dataForm.checkerIds"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Unassigned",
      "value": -1
    }
  }), _vm._l(_vm.userList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.nickname || item.username,
        "value": item.id
      }
    });
  })], 2)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "select reviewer",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.auditorIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "auditorIds", $$v);
      },
      expression: "dataForm.auditorIds"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Unassigned",
      "value": -1
    }
  }), _vm._l(_vm.userList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.nickname || item.username,
        "value": item.id
      }
    });
  })], 2)], 1), _c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "width": "384px"
    },
    attrs: {
      "value-format": "timestamp",
      "type": "daterange",
      "range-separator": "~",
      "start-placeholder": "Start Time",
      "end-placeholder": "End Time"
    },
    model: {
      value: _vm.watchStartToEndMillisecondTimeRange,
      callback: function callback($$v) {
        _vm.watchStartToEndMillisecondTimeRange = $$v;
      },
      expression: "watchStartToEndMillisecondTimeRange"
    }
  })], 1), _c('el-form-item', [_c('el-select-all', {
    attrs: {
      "optionList": _vm.applymentStatusExcludeDraftList,
      "placeholder": "Status"
    },
    on: {
      "elSelectAllChange": function elSelectAllChange(list) {
        _vm.dataForm.applymentStatus = list;
      }
    }
  })], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "Linked Transaction"
    },
    model: {
      value: _vm.linkedTransaction,
      callback: function callback($$v) {
        _vm.linkedTransaction = $$v;
      },
      expression: "linkedTransaction"
    }
  }, _vm._l(_vm.linkedTransactionList, function (item) {
    return _c('el-option', {
      key: item.title,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Entity Type"
    },
    model: {
      value: _vm.dataForm.businessGenre,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessGenre", $$v);
      },
      expression: "dataForm.businessGenre"
    }
  }, _vm._l(_vm.entityTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "multiple": "",
      "clearable": "",
      "placeholder": "Risk Rating"
    },
    model: {
      value: _vm.dataForm.riskRating,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "riskRating", $$v);
      },
      expression: "dataForm.riskRating"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Blank",
      "value": "null"
    }
  }), _vm._l(_vm.riskRatingTypes, function (item) {
    return _c('el-option', {
      key: item.title,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  })], 2)], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Supplier"
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "debounce",
      rawName: "v-debounce"
    }],
    attrs: {
      "icon": "el-icon-search",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.getDataList(1);
      }
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _c('div', {
    attrs: {
      "id": "operationArea"
    }
  }, [_vm.isAuth('company:audit') ? _c('el-button', {
    staticClass: "mb16",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small",
      "icon": "el-icon-thumb",
      "disabled": _vm.dataListSelections.length <= 0
    },
    on: {
      "click": _vm.handleBatchAudit
    }
  }, [_vm._v(" Reviewer Finish Approve ")]) : _vm._e(), _vm.isAuth('company:audit') ? _c('el-button', {
    staticClass: "mb16",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small",
      "icon": "el-icon-thumb",
      "disabled": _vm.dataListSelections.length <= 0
    },
    on: {
      "click": _vm.handleBatchRefundAudit
    }
  }, [_vm._v(" Reviewer Refund Approve ")]) : _vm._e(), _vm.isAuth('company:audit') ? _c('el-button', {
    staticClass: "mb16",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small",
      "icon": "el-icon-download",
      "loading": _vm.batchDownBtnLoading,
      "disabled": _vm.dataListSelections.length <= 0
    },
    on: {
      "click": _vm.handleExportExcel
    }
  }, [_vm._v(" Export Excel ")]) : _vm._e(), _c('el-button', {
    staticClass: "mb16",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small",
      "icon": "el-icon-arrow-down"
    },
    on: {
      "click": _vm.expandAllHandle
    }
  }, [_vm._v("Expand All")]), _c('el-button', {
    staticClass: "mb16",
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small",
      "icon": "el-icon-arrow-up"
    },
    on: {
      "click": _vm.collapseAllHandle
    }
  }, [_vm._v("Collapse All")])], 1), _c('div', {
    staticClass: "tableWrap"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    ref: "applymentTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "600",
      "data": _vm.dataList,
      "default-sort": {
        prop: 'createTime',
        order: 'descending'
      },
      "row-class-name": _vm.getRowClassName
    },
    on: {
      "selection-change": _vm.selectionChangeHandle,
      "sort-change": _vm.tableSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "width": "30px",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c('Expand', {
          attrs: {
            "adjustmentList": props.row.adjustmentList || []
          }
        })];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "40",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "applymentNo",
      "align": "center",
      "label": "Transaction No.",
      "fixed": "left",
      "width": "140"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Supplier",
      "width": "200",
      "fixed": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.supplierAbbrDeduplicateFormat(scope.row.supplierList)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "label": "Create Time",
      "width": "130",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "commitTime",
      "align": "center",
      "label": "Submit Time",
      "width": "140",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "terminatedTime",
      "align": "center",
      "label": "Terminated Time",
      "width": "170",
      "sortable": "custom"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Client Code",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$acraCompan;

        return [((_scope$row$acraCompan = scope.row.acraCompanyInfoList) === null || _scope$row$acraCompan === void 0 ? void 0 : _scope$row$acraCompan.length) > 0 ? _c('span', [_vm._v(_vm._s(_vm.clientCodeDeduplicateFormat(scope.row.acraCompanyInfoList)))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "riskAssessmentData.rating",
      "align": "center",
      "label": "Risk Rating",
      "width": "102"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.riskAssessmentData ? _c('p', [_vm._v(_vm._s(_vm.riskRatingFormat(scope.row.riskAssessmentData.rating)))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "applymentStatus",
      "align": "center",
      "label": "Status",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.applymentStatusFormat(scope.row.applymentStatus)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Linked Transaction",
      "width": "160",
      "formatter": _vm.linkedTransactionFormat
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Linked Engagement ID",
      "width": "184"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$engagement;

        return [((_scope$row$engagement = scope.row.engagementList) === null || _scope$row$engagement === void 0 ? void 0 : _scope$row$engagement.length) > 0 ? _c('span', [_vm._v(_vm._s(_vm.engagementIdDeduplicateFormat(scope.row.engagementList)))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "businessGenre",
      "align": "center",
      "label": "Entity Type",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.entityTypeFormat(scope.row.businessGenre)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "applicantName",
      "align": "center",
      "label": "Applicant Name",
      "width": "140"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "applicantEmail",
      "align": "center",
      "label": "Applicant Email",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "country",
      "align": "center",
      "label": "Country of Company",
      "width": "180"
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Entity Name",
      "width": "360"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$fundInfoLi, _scope$row$fundInfoLi2;

        return [_vm._l(_vm.proposedCompanyNameFormat(scope.row), function (name, index) {
          return _c('div', {
            key: "entityName-".concat(scope.row.id, "-").concat(index)
          }, [_vm._v(" " + _vm._s(name) + " ")]);
        }), ((_scope$row$fundInfoLi = scope.row.fundInfoList) === null || _scope$row$fundInfoLi === void 0 ? void 0 : _scope$row$fundInfoLi.length) > 0 ? _c('div', [_vm._v(" " + _vm._s((_scope$row$fundInfoLi2 = scope.row.fundInfoList.map(function (item) {
          return item.fundName;
        })) === null || _scope$row$fundInfoLi2 === void 0 ? void 0 : _scope$row$fundInfoLi2.join(", ")) + " ")]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Billing Party",
      "width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$orderInfoL;

        return [((_scope$row$orderInfoL = scope.row.orderInfoList) === null || _scope$row$orderInfoL === void 0 ? void 0 : _scope$row$orderInfoL.length) > 0 ? _c('span', [_vm._v(" " + _vm._s(_vm.billingPartyDeduplicateFormat(scope.row.orderInfoList)) + " ")]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "coordinator",
      "align": "center",
      "label": "Coordinator",
      "width": "180",
      "formatter": _vm.operatorStaffFormat
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "checker",
      "align": "center",
      "label": "Checker",
      "width": "180",
      "formatter": _vm.operatorStaffFormat
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "auditor",
      "align": "center",
      "label": "Reviewer",
      "width": "180",
      "formatter": _vm.operatorStaffFormat
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Action",
      "fixed": "right",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.detailHandler(scope.row.id);
            }
          }
        }, [_vm._v("Detail")])];
      }
    }])
  })], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  })], 1), _c('batch-audit', {
    ref: "batchAuditModal",
    on: {
      "refreshDataList": _vm.getDataList
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }